import { call, fork, put, select, take } from "redux-saga/effects";

import { createApiClient, IApiClient } from "../../infra/api/client";

import { handleErrorForHandler } from "./handleErrorForHandler";

import { Company } from "../../domain/model/company";
import { User } from "../../domain/model/user";
import { ICompanyRepository } from "../../domain/repository/company_repository";
import { createCompanyAPI } from "../../infra/api/service/company_api";
import {
  ClientBillingActionType,
  createClientBillingActionCreator,
  IClientBillingActionCreator,
  IRequestCreatePaymentInfoAction,
} from "../action/client_billing_action";
import {
  CreatePaymentInfoByClientBillingResponse,
  GetCompanyByClientBillingResponse,
} from "../response/company_response";
import { AppState } from "../store/app_state";
import { AuthState } from "../store/auth_state";

const apiClient: IApiClient = createApiClient();
const companyRepository: ICompanyRepository = createCompanyAPI(apiClient);
const actionCreator: IClientBillingActionCreator =
  createClientBillingActionCreator();

function* handleGetCompanyInClientClientBilling() {
  while (true) {
    try {
      yield take(ClientBillingActionType.REQUEST_GET_COMPANY);
      const authSelector = (state: AppState) => state.authReducer;
      const _authState: AuthState = yield select(authSelector);
      const user: User | null = _authState.user;
      const companyID = user ? (user.client ? user.client.companyID : "") : "";
      const company: Company = yield call(getCompany, companyID);

      const res: GetCompanyByClientBillingResponse =
        new GetCompanyByClientBillingResponse();
      res.company = company;

      yield put(actionCreator.callbackGetCompanyAction(true, res));
    } catch (error) {
      yield fork(handleErrorForHandler, error);
      yield put(actionCreator.callbackGetCompanyAction(false));
    }
  }
}

function* handleCreatePaymentInfoInClientClientBilling() {
  while (true) {
    try {
      const action: IRequestCreatePaymentInfoAction = yield take(
        ClientBillingActionType.REQUEST_CREATE_PAYMENT_INFO
      );

      const authSelector = (state: AppState) => state.authReducer;
      const _authState: AuthState = yield select(authSelector);
      const user: User | null = _authState.user;
      const companyID = user ? (user.client ? user.client.companyID : "") : "";
      const company: Company = yield call(getCompany, companyID);

      const res: CreatePaymentInfoByClientBillingResponse =
        new CreatePaymentInfoByClientBillingResponse();
      res.company = company;
      yield put(actionCreator.callbackCreatePaymentInfoAction(true, res));
    } catch (error) {
      yield fork(handleErrorForHandler, error);
      yield put(actionCreator.callbackCreatePaymentInfoAction(false));
    }
  }
}

const getCompany = (companyID: string) => {
  return companyRepository.get(companyID);
};

export {
  handleCreatePaymentInfoInClientClientBilling,
  handleGetCompanyInClientClientBilling,
};



// WEBPACK FOOTER //
// ./src/presentation/handler/client_billing_handler.ts